<template>
  <div class="root">
    <div class="left-box">
      <div class="images-wrapper">
        <img
          src="@/assets/fold4/left-pics.png"
          alt="left demo"
          class="images"
        />
      </div>
    </div>
    <div class="right-box">
      <div class="title">
        Inspired from
        <span style="color: #d35c34; font-style: italic">FLOWERS</span>
      </div>
      <div class="subtitle">
        {{ `CỔ ĐIỂN & HIỆN ĐẠI` }}
      </div>
      <div class="description">
        Mặt đồng hồ được chạm khắc vân Guilloche - biểu tượng của nghệ thuật chế
        tác mang âm hưởng cổ điển sang trọng, pha trộn các chi tiết hiện đại là
        cọc số và dây kim loại thanh mảnh, làm nổi bật sự mềm mại của Florenge.
      </div>
      <div class="attributes">
        <div class="attribute">
          <span class="label">SIZE</span>
          <span class="value">34mm</span>
        </div>
        <div class="attribute">
          <span class="label">CHỐNG NƯỚC</span>
          <span class="value">3ATM</span>
        </div>
        <div class="attribute">
          <span class="label">MẶT KÍNH</span>
          <span class="value">Sapphire</span>
        </div>
        <div class="attribute">
          <span class="label">CHẤT LIỆU DÂY</span>
          <span class="value">Stainless Steel</span>
        </div>
      </div>
      <div class="cta-text-container">
        <span class="cta-text" @click="redirectToCurnon">MUA NGAY</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fold4",
  methods: {
    redirectToCurnon() {
      window.location.href =
        "https://curnonwatch.com/dong-ho/dong-ho-nu/dong-ho-nu-florenge";
    },
  },
};
</script>
<style lang="scss" scoped>
.root {
  padding: 80px 0;
  .left-box {
    position: relative;
    .images-wrapper {
      padding: 24px;
      padding-top: 0;
      .images {
        max-width: 100%;
      }
    }
  }
  .right-box {
    margin-top: 32px;
    .title {
      font-family: "Rollgates Fabulous", sans-serif;
      font-weight: normal;
      font-size: 48px;
      line-height: 54px;
      text-align: center;
      margin-bottom: 24px;
    }
    .subtitle {
      font-family: "SVN-Gotham", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 20px;
      line-height: 26px;
      letter-spacing: 0.2em;
      text-align: center;
      margin-bottom: 40px;
    }
    .description {
      padding: 16px;
      font-family: "SVN-Gotham", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
      color: rgba(0, 0, 0, 0.6);
      text-align: center;
    }
    .attributes {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      row-gap: 24px;
      margin-bottom: 40px;
      .attribute {
        width: 50%;
        display: flex;
        flex-direction: column;
        text-align: center;
        .label {
          font-family: "SVN-Gotham", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0.03em;
          color: rgba(0, 0, 0, 0.6);
        }
        .value {
          font-family: "Rollgates Fabulous", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 20px;
          line-height: 24px;
          color: #000000;
        }
      }
    }
    .cta-text-container {
      text-align: center;
      .cta-text {
        cursor: pointer;
        font-family: "SVN-Gotham", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.03em;
        color: #d35c34;
        padding-bottom: 3px;
        border-bottom: 1px solid #d35c34;
      }
    }
  }
}
@media (min-width: 1024px) {
  .root {
    display: flex;
    flex-direction: row;
    .left-box {
      flex: 1;
      text-align: center;
      display: flex;
      justify-content: center;
      padding-left: 32px;
      .images-wrapper {
        /* max-width: 780px; */
        /* width: 80%; */
        .images {
          max-width: 100%;
        }
      }
    }
    .right-box {
      flex: 1;
      padding: 48px;
      .title {
        text-align: left;
      }
      .subtitle {
        text-align: left;
        white-space: nowrap;
        margin-bottom: 64px;
      }
      .description {
        text-align: left;
        padding-left: 0;
        margin-bottom: 64px;
        font-size: 16px;
      }
      .attributes {
        max-width: 75%;
        row-gap: 48px;
        margin-bottom: 96px;
        .attribute {
          text-align: left;
        }
      }
      .cta-text-container {
        text-align: left;
      }
    }
  }
}
</style>